module.exports = __webpack_public_path__ + "static/img/new.d613c02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new.jpg
// module id = q/NN
// module chunks = 1